import React from 'react';
import { Filter, X } from 'lucide-react';

interface UserFiltersProps {
  roleFilter: string | null;
  planFilter: string | null;
  onRoleChange: (role: string | null) => void;
  onPlanChange: (plan: string | null) => void;
}

const ROLES = ['admin', 'freelancer', 'client'];
const PLANS = ['free', 'basic', 'pro', 'enterprise', 'company'];

export const UserFilters: React.FC<UserFiltersProps> = ({
  roleFilter,
  planFilter,
  onRoleChange,
  onPlanChange,
}) => {
  const hasActiveFilters = roleFilter || planFilter;

  const clearAllFilters = () => {
    onRoleChange(null);
    onPlanChange(null);
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-2 text-gray-500">
        <Filter size={14} />
        <span className="text-sm font-medium">Filters:</span>
      </div>

      {/* Role Filter */}
      <select
        value={roleFilter || ''}
        onChange={(e) => onRoleChange(e.target.value || null)}
        className="px-3 py-1.5 bg-white border border-gray-300 rounded text-sm focus:border-gray-400 focus:outline-none"
      >
        <option value="">All Roles</option>
        {ROLES.map((role) => (
          <option key={role} value={role}>
            {role.charAt(0).toUpperCase() + role.slice(1)}
          </option>
        ))}
      </select>

      {/* Plan Filter */}
      <select
        value={planFilter || ''}
        onChange={(e) => onPlanChange(e.target.value || null)}
        className="px-3 py-1.5 bg-white border border-gray-300 rounded text-sm focus:border-gray-400 focus:outline-none"
      >
        <option value="">All Plans</option>
        {PLANS.map((plan) => (
          <option key={plan} value={plan}>
            {plan.charAt(0).toUpperCase() + plan.slice(1)}
          </option>
        ))}
      </select>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <button
          onClick={clearAllFilters}
          className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded transition-colors flex items-center gap-1"
        >
          <X size={14} />
          Clear
        </button>
      )}
    </div>
  );
};
